/**
 * SF-4758: a read that failed, with a Retry. Shown in place of the data so a failed read never
 * looks like real data (blank weights, an empty history, items that seem deleted).
 */
import { Alert, Button } from 'antd';
import { prioritiesErrorMessage } from '../api/prioritiesClient';

export const LoadError: React.FC<{ error: unknown; fallback: string; onRetry: () => unknown }> = ({
  error,
  fallback,
  onRetry,
}) => (
  <Alert
    type="error"
    showIcon
    message={prioritiesErrorMessage(error, fallback)}
    action={
      <Button size="small" onClick={() => void onRetry()}>
        Retry
      </Button>
    }
  />
);

/**
 * A background refresh that failed while good data is already shown. Every write refreshes
 * every priorities read, so one failed refetch must not swap the page for an error (that would
 * unmount the tabs and lose an unsaved ranking): the last answer stays, with this warning above.
 */
export const RefreshWarning: React.FC<{
  error: unknown;
  fallback: string;
  onRetry: () => unknown;
}> = ({ error, fallback, onRetry }) => (
  <Alert
    type="warning"
    showIcon
    message={`${prioritiesErrorMessage(error, fallback)} Showing what was loaded before.`}
    action={
      <Button size="small" onClick={() => void onRetry()}>
        Retry
      </Button>
    }
  />
);
